import { Alert, Box, Divider, Grid } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { Add, Check, Delete } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { MaxReceipt, MaxReceiptSize, ValidTextRegExp } from "../../../Constant";
import { MyButton } from "../../../components/my-button/MyButton";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import MyContext from "../../../contexts/MyContext";

export const AddReceipt = (props) => {
  const myContext = useContext(MyContext);
  const { t } = useTranslation();
  const [receipt, setReceipt] = useState(props.receipt);
  const [totalCost, setTotalCost] = useState(props.totalCost);
  const [totalCostErr, setTotalCostErr] = useState("");
  const [error, setError] = useState(null);
  const hiddenFileInput = React.useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const removeReceipt = (fileName) => {
    setReceipt(receipt.filter((item) => item.name !== fileName));
  };

  const removeAllReceipt = () => {
    setReceipt([]);
    setTotalCost("");
    props.onSave([], "");
  };

  const handleSave = () => {
    let isValid = true;

    if (totalCost?.trim() || (receipt && receipt.length > 0)) {

      if (!totalCost || totalCost.trim() === "") {
        setTotalCostErr("total_cost_required");
        isValid = false;
      } else setTotalCostErr("");

      if (!receipt || receipt.length === 0) {
        setError("receipt_required");
        isValid = false;
      } else setError(null);
    }

    if (isValid) props.onSave(receipt, totalCost);
  };

  const handleChangeTotalCost = (value) => {
    if (Number(value) > Number(myContext.totalCostSEKMax)) setTotalCost("");
    else setTotalCost(value);
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    if (myContext.allowFileUploadExtension.find((extension) => fileUploaded.name.toLowerCase().endsWith(extension.toLowerCase())) == null) setError("not_allowed");
    else if (fileUploaded.size > MaxReceiptSize) setError("your_uploaded_file_too_big");
    else {
      setReceipt((oldArray) => [...oldArray.filter((item) => item.name !== fileUploaded.name), fileUploaded]);
      setError(null);
    }
  };

  useEffect(() => {
    if (!props.open) setError(null);
  }, [props.open]);

  return (
    <MyContext.Consumer>
      {(context) => (
        <>
          {error && (
            <Alert variant="filled" severity="error" className="margin top-1 bottom-1">
              {t(error)}
            </Alert>
          )}
          {(!receipt || receipt.length > 0) && (
            <>
              <Divider />
              {receipt.map((item, key) => (
                <Grid container key={key} justifyContent="space-between" alignItems={"center"} wrap="nowrap" className="margin top-1 bottom-1">
                  <Grid xs={10} sm={10} color="primary.main" item container wrap="nowrap" alignItems={"center"} style={{ overflowX: "hidden" }}>
                    <Check color="primary.main" style={{ marginRight: "1rem" }} />
                    <Box whiteSpace={"nowrap"} component="span" color="primary.main">
                      {item.name}
                    </Box>
                  </Grid>
                  <Delete style={{ marginLeft: "1rem", cursor: "pointer" }} onClick={(e) => removeReceipt(item.name)} />
                </Grid>
              ))}
            </>
          )}
          {(!receipt || receipt.length < MaxReceipt) && (
            <>
              <Divider />
              <Grid onClick={handleClick} container alignItems="center" className="selector margin top-1 bottom-1">
                <Add style={{ marginRight: "1rem" }} />
                <span>{t("add_image_of_receipt")}</span>
              </Grid>
              <input accept={context.allowFileUploadExtension.map((extension) => `.${extension}`.toLowerCase()).join()} type="file" ref={hiddenFileInput} onChange={handleChange} style={{ display: "none" }} />
            </>
          )}
          <Divider />
          <MyTextField regExp={"^[0-9]*$"} helperText={t(totalCostErr)} type="text" value={totalCost} label={t("total_cost")} onChange={handleChangeTotalCost} />
          <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
            <Grid item>
              <MyButton textTransform="none" color="secondary" onClick={removeAllReceipt} text={t("remove")} />
            </Grid>
            <Grid item>
              <MyButton textTransform="none" color="secondary" text={t("save")} onClick={handleSave} />
            </Grid>
          </Grid>
        </>
      )}
    </MyContext.Consumer>
  );
};
